<template>
    <div class="main-div">
        <hr style="opacity: 0.1; margin-bottom: 70px" />
        <div class="header">
            <p class="headerText">Trusted by some of the leading Agri brands</p>
        </div>
        <div style="">
            <div class="crousalContainer">
                <div class="text-container" id="gallery">
                    <div class="imagecontainer" >
                        <img
                            width="100%"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/mahindrabrokers.png"
                            alt=""
                        />
                    </div>

                    <div class="imagecontainer">
                        <img
                            width="161px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/cropscience.png"
                            alt=""
                        />
                    </div>
                    <div class="imagecontainer">
                        <img width="61px" height="56px" src="../../../assets/trustedCompaniesLogo/mrf.png" alt="" />
                    </div>

                    <div style=" padding-right: 50px">
                        <img width= "163px" height="56px" src="../../../assets/trustedCompaniesLogo/sonalikaLeading.png" alt="" />
                    </div>

                    <div class="imagecontainer">
                        <img width="117px" height="56px" src="../../../assets/trustedCompaniesLogo/kubota.png" alt="" />
                    </div>
                    <div class="imagecontainer">
                        <img width="67px" height="56px" src="../../../assets/trustedCompaniesLogo/yara.svg" alt="" />
                    </div>

                    <div class="imagecontainer">
                        <img width="108px" height="56px" src="../../../assets/trustedCompaniesLogo/upaj.svg" alt="" />
                    </div>
                    <div class="imagecontainer">
                        <img width="142px" height="56px" src="../../../assets/trustedCompaniesLogo/solis.png" alt="" />
                    </div>

                    <div class="imagecontainer">
                        <img
                            width="158px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/mahindrahomefinance.png"
                            alt=""
                        />
                    </div>

                    <div class="imagecontainer">
                        <img
                            width="173px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/farmart.png"
                            alt=""
                        />
                    </div>
                    <div class="imagecontainer">
                        <img
                            width="80px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/iplbiological.png"
                            alt=""
                        />
                    </div>
                    <div class="imagecontainer">
                        <img
                            width="140px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/staragri.png"
                            alt=""
                        />
                    </div>

                   
                </div>
                <div class="text-containersecond" id="gallerysecond">
                    <div class="imagecontainer">
                        <img
                            width="174px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/shaktivardhak.png"
                            alt=""
                        />
                    </div>
                    <div class="imagecontainer">
                        <img
                            width="88px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/gramophone.png"
                            alt=""
                        />
                    </div>
                    <div class="imagecontainer">
                        <img width="114px" height="56px" src="../../../assets/trustedCompaniesLogo/carnot.png" alt="" />
                    </div>
                    <div class="imagecontainer">
                        <img
                            width="126px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/dcmshriram.png"
                            alt=""
                        />
                    </div>
                    <div class="imagecontainer">
                        <img width="172px" height="56px" src="../../../assets/trustedCompaniesLogo/efeed.png" alt="" />
                    </div>
                    <div class="imagecontainer">
                        <img width="180px" height="56px" src="../../../assets/trustedCompaniesLogo/godrej.png" alt="" />
                    </div>
                    <div class="imagecontainer">
                        <img width="80px" height="56px" src="../../../assets/trustedCompaniesLogo/Agrifi.png" alt="" />
                    </div>
                    <div class="imagecontainer">
                        <img
                            width="128px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/sarvagram.png"
                            alt=""
                        />
                    </div>
                    <div class="imagecontainer">
                        <img
                            width="160px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/JaiKishan.svg"
                            alt=""
                        />
                    </div>
                    <div class="imagecontainer">
                        <img
                            style="margin-top: 12px"
                            width="141px"
                            height="42px"
                            src="../../../assets/trustedCompaniesLogo/ergos.png"
                            alt=""
                        />
                    </div>
                    <div class="imagecontainer">
                        <img width="112px" height="56px" src="../../../assets/trustedCompaniesLogo/vegrow.png" alt="" />
                    </div>
                    <div class="imagecontainer">
                        <img
                            width="74px"
                            height="56px"
                            src="../../../assets/trustedCompaniesLogo/merapashu.svg"
                            alt=""
                        />
                    </div>
                </div>
              
            </div>

            <div class="header">
               
            </div>

            <!-- your carousel items here -->

            <hr class="bottomhr" />
        </div>
    </div>
</template>

<script>
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
import "slick-carousel/slick/slick.js";

export default {
    name: "TrustedCompanies",

    mounted() {
        $("#gallery").slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5,
            speed: 6500,
            pauseOnHover: true,
            cssEase: "linear",
            variableWidth: true,
            useTransform:true,
            waitForAnimate:true,
            pauseOnHover:false
            // edgeFriction:0
            // easing:'linear'
        });
        $("#gallerysecond").slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5,
            speed: 6500,
            pauseOnHover: true,
            cssEase: "linear",
            variableWidth: true,
            waitForAnimate:true,
            pauseOnHover:false

        });
    },
    // beforeDestroy() {
    //     $(this.$el)?.slick("unslick");
    // },
};
</script>

<style lang="scss" scoped>
.slider {
    display: flex;
    flex-direction: row;
}
.slide img {
}
.slick-slide {
    width: 50%;
}

.bottomhr {
    opacity: 0.1;
    margin-bottom: 160px;
}
.crousalContainer {
    width: 96%;
    margin-bottom: 30px;
    overflow: hidden;
    margin: 0px auto;
    display: flex;
    flex-wrap: wrap;
}
.main-div {
    margin: 0px auto;
}
.crousalContainer-right {
    width: 96%;
    margin: 0px auto;
    overflow: hidden;
}

.crousalContainer-third {
    width: 96%;
    margin: 0px auto;
    overflow: hidden;
}

.header {
    margin-top: 30px;
    margin-bottom: 60px;
}

.headerText {
    font-weight: 400;
    font-size: 28px;
    line-height: 38px;
    text-align: center;
    color: #797e79;
}
.BottomText {
    font-weight: 400;
    font-size: 20px;
    line-height: 38px;
    text-align: center;
    color: #797e79;
}

.text-container {
    width: 100%;
    gap: 96px;
    display: flex;
    justify-content: center;

    flex-wrap: wrap;
}
.text-containersecond{
    width: 100%;
    gap: 96px;
    display: flex;
    justify-content: center;
margin-top: 20px;
    flex-wrap: wrap;
}
.imagecontainer{
    padding-right: 50px;
}
.text-container-right {
    width: 100%;
    display: flex;
    gap: 36px;
    margin-top: 20px;
    justify-content: center;
}
.text-container-third {
    width: 100%;
    display: flex;
    gap: 5px;
    margin-top: 20px;
    justify-content: center;
}

@media all and (max-width: 1024px) {
    .text-container {
        gap: 30px;
    }
}

@media all and (max-width: 959px) {
    .text-container {
        gap: 5px;
    }
}
@media all and (max-width: 959px) {
    .text-container-right {
        gap: 5px !important;
    }
}
@media all and (max-width: 1024px) {
    .text-container-right {
        gap: 10px;

        margin-top: 20px;
    }
}
@media all and (max-width: 1024px) {
    .headerText {
        font-size: 18px;
        margin-bottom: 0px;
    }
}
@media all and (max-width: 1024px) {
    .BottomText {
        font-size: 16px;
        margin-bottom: 0px;
    }
}
@media all and (max-width: 1024px) {
    .bottomhr {
        margin-bottom: 60px;
    }
}
@media all and (max-width: 1024px) {
    .imagecontainer {
        padding-right: 20px;
}
}
</style>
